import types from './types';

const initialState = {
  fetchingMenus: false,
  menus: [],
  menuIdsFetched: [],
  menuFetchError: '',
  copyingMenu: false,
  archivingMenu: false
};

export const menuReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_MENUS_REQUEST: {
      return {
        ...state,
        fetchingMenus: true,
        menuFetchError: ''
      };
    }
    case types.GET_MENUS_SUCCESS: {
      const { menus } = action;
      const menusForRedux = [...state.menus];
      const menuIdsForRedux = [...state.menuIdsFetched];

      // only store unique menus
      menus.forEach(menu => {
        const { menuId } = menu;

        if (!menuIdsForRedux.includes(menuId)) {
          menuIdsForRedux.push(menuId);
          menusForRedux.push(menu);
        }
      });

      return {
        ...state,
        menus,
        fetchingMenus: false,
        menuIdsFetched: [...menuIdsForRedux],
        menuFetchError: ''
      };
    }
    case types.GET_MENUS_FAILURE: {
      return {
        ...state,
        fetchingMenus: false,
        menuFetchError: action.error
      };
    }
    case types.COPY_MENU_REQUEST: {
      return {
        ...state,
        copyingMenu: true
      };
    }
    case types.COPY_MENU_SUCCESS:
    case types.COPY_MENU_FAILURE: {
      return {
        ...state,
        copyingMenu: false
      };
    }
    case types.ARCHIVE_MENU_REQUEST: {
      return {
        ...state,
        archivingMenu: true
      };
    }
    case types.ARCHIVE_MENU_SUCCESS: {
      let menusCopy = [...state.menus];
      let menuIdsCopy = [...state.menuIdsFetched];

      menusCopy = menusCopy.filter(menu => menu.menuId !== action.menuId);
      menuIdsCopy = menuIdsCopy.filter(id => id !== action.menuId);

      return {
        ...state,
        archivingMenu: false,
        menus: menusCopy,
        menuIdsFetched: menuIdsCopy
      };
    }
    case types.ARCHIVE_MENU_FAILURE: {
      return {
        ...state,
        archivingMenu: false
      };
    }
    default:
      return state;
  }
};
